module.exports = __webpack_public_path__ + "img/france-ill-defined-causes-male.25d6fcfa.png";